import {
    PStepperHorizontal,
    PStepperHorizontalItem,
    type StepperHorizontalItemState,
} from '@porsche-design-system/components-react';
import React, { useCallback, useMemo } from 'react';
import { type StepsProps } from '../context';

const Steps = ({ items, current, stepRedirectOnClick, disableAtFinalStep }: StepsProps) => {
    const stepState = useMemo(
        () =>
            items.map(item => {
                if (item.index < current) {
                    return {
                        ...item,
                        status: 'complete' as StepperHorizontalItemState,
                    };
                }

                if (item.index === current) {
                    return {
                        ...item,
                        status: 'current' as StepperHorizontalItemState,
                    };
                }

                return {
                    ...item,
                    status: undefined,
                    disabled: true,
                };
            }),
        [current, items]
    );

    const handleStepClick = useCallback(
        (index: number, status: StepperHorizontalItemState, preventClickPreviousStep: boolean) => {
            if (status === 'complete' && !preventClickPreviousStep) {
                stepRedirectOnClick?.(index);
            }
        },
        [stepRedirectOnClick]
    );

    return (
        <PStepperHorizontal>
            {stepState.map(item => {
                const preventClickPreviousStep =
                    disableAtFinalStep && current + 1 === stepState.length ? item.index + 1 < stepState.length : false;

                return (
                    <PStepperHorizontalItem
                        key={`stepper-${item.index}`}
                        disabled={item.disabled}
                        onClick={() => handleStepClick(item.index, item.status, preventClickPreviousStep)}
                        state={item.status}
                    >
                        {item.title}
                    </PStepperHorizontalItem>
                );
            })}
        </PStepperHorizontal>
    );
};

export default Steps;
